module.exports = __webpack_public_path__ + "static/fonts/PorscheNextUrduTT-Regular.7efad7b8.ttf";